// Description: Page that render the configuration features
// Updated: 20/08/2025
// Author: Simon Franklin

// React
import React, { useEffect, useState } from 'react';

// Material UI Component
import { Box } from '@mui/material'

// Components and Functions
import Sidebar, { sidebarDatabase } from './Sidebar'
import SubPage from './Subpage';
import MobileNavbar from './MobileNavbar';

// Render The Page
const ConfigurationPage = () => {
  const [selectedOption, setSelectedOption] = useState(sidebarDatabase[0]);
  const [page, setPage] = useState('General');

  useEffect(() => {
    setPage(selectedOption.page)
  }, [selectedOption])


  return (
    <Box sx={{
      backgroundColor: '#FFF',
      minHeight: { sm: '100vh' },
      display: 'flex',
      flexDirection: { xs: 'column-reverse', sm: 'row' }
    }}>
      <MobileNavbar selected={selectedOption} setSelected={setSelectedOption} />
      <Sidebar selected={selectedOption} setSelected={setSelectedOption} />
      <SubPage page={page} />
    </Box>
  )
}

export default ConfigurationPage